import { DashboardEntry } from '../api/dashboard'
import { ClientFormatter } from '../components/client-formatter'
import { CurrencyFormatter } from '../components/currency-formatter'
import { DateFormatter } from '../components/date-formatter'
import { LocationFormatter } from '../components/location-formatter'

export function EntryTooltip({ entry }: { entry: DashboardEntry }) {
	return (
		<div className="grid grid-cols-[auto_auto] gap-x-4 gap-y-1">
			<div>ID:</div>
			<div>{entry.id}</div>
			<div>Čas od:</div>
			<div>
				<DateFormatter date={entry.date_from} />
			</div>
			<div>Čas do:</div>
			<div>
				<DateFormatter date={entry.date_to} />
			</div>
			<div>Pobočka:</div>
			<div>
				<LocationFormatter id={entry.location_from} />
				{' → '}
				<LocationFormatter id={entry.location_to} />
			</div>
			<div>Cena:</div>
			<div>
				<CurrencyFormatter value={entry.price} />
				/d <br />
			</div>
			<div>Klient:</div>
			<div>
				<ClientFormatter id={entry.client_id} />
			</div>
		</div>
	)
}
